"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedwindysm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 13",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedwindysm` : '') + (description ? ` desc-brandedwindysm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedwindysm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedwindysm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 5.94c0-1.53-1.1-2.8-2.56-3.07a4.7 4.7 0 0 0-8.32-.63 3.6 3.6 0 0 0-5.56 1.92C2.75 3.7.98 4.93.98 6.57c0 1.64 1.73 2.85 3.55 2.41a2.81 2.81 0 0 0 4.57.3 5 5 0 0 0 8.9-.21 3.13 3.13 0 0 0 3-3.13Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7 8.12H.3a.31.31 0 0 1 0-.63h10.4c.25 0 .48-.1.66-.27a.93.93 0 0 0-.65-1.6c-.4 0-.75.26-.88.63a.31.31 0 0 1-.4.19.31.31 0 0 1-.2-.4 1.56 1.56 0 1 1 1.47 2.08Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.54 12.27c-.66 0-1.25-.42-1.46-1.04a.31.31 0 1 1 .59-.21c.13.37.48.62.87.62a.93.93 0 0 0 0-1.86H.31a.31.31 0 0 1 0-.63h6.24A1.54 1.54 0 0 1 8.1 10.7a1.56 1.56 0 0 1-1.55 1.56Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedwindysm;